import { styled } from "@mui/material/styles";
const CardLayoutMain = styled("div")(({ theme }) => ({
  border: "1px solid #000000",
  borderRadius: "16px",
  padding: "12px",
  marginTop: "2.3rem",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    marginTop: "0.3rem",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "0.3rem",
  },
  "& .CardType_image": {
    "& img": {
      width: "30px",
      objectFit: "cover",
    },
  },
}));
const CardType = styled("div")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "21px",
  color: "#0B0B0B",
  fontFamily: theme.typography.Poppins,
  textAlign: "right",
}));
const CardNumber = styled("div")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "24px",
  lineHeight: "29px",
  letterSpacing: "0.02em",
  color: theme.palette.colors.BlackBean,
  fontFamily: theme.typography.Poppins,
  marginTop: "30px",
  marginRight: "5px",

  [theme.breakpoints.down("sm")]: {
    fontSize: "19px",
  },
}));
const CardName = styled("div")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: theme.palette.colors.BlackBean,
  fontFamily: theme.typography.Poppins,

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
const CardDateMain = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "10px",
  "& .date": {
    display: "flex",
    alignItems: "center",
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "21px",
      color: theme.palette.colors.BlackBean,
      fontFamily: theme.typography.Poppins,
      marginLeft: "8px",
    },
  },
}));

export { CardLayoutMain, CardType, CardNumber, CardName, CardDateMain };
